<app-side-bar [mode]="sidebarMode"></app-side-bar>
<app-header mode="landing"> </app-header>

<div class="landing-page-content">
  <div
    class="privacy-container w-full py-4 px-4 md:px-6 text-[#b6c2d6] font-sans selection:bg-[#f3a83b]/30 selection:text-white"
  >
    <div class="w-full space-y-6">
      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl"
      >
        <span
          class="text-[10px] uppercase tracking-widest text-slate-400 font-bold block mb-1"
          >Casinoze Legal Terms</span
        >
        <h2
          class="text-3xl md:text-4xl font-extrabold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif] mb-4"
        >
          Terms <span class="text-[#e7b53f]">& Conditions</span>
        </h2>
        <div
          class="text-[#b6c2d6] space-y-3 leading-relaxed"
          style="font-size: 0.82rem"
        >
          <p>
            These Legal Terms constitute a legally binding agreement between
            <strong>Casinoze</strong> and you, governing your access to and use
            of our website, mobile application, and any related services. By
            accessing or using the Services, you acknowledge that you have read,
            understood, and agree to be bound by these Legal Terms.
          </p>
          <p>
            The Services are intended for individuals who are at least
            <strong class="text-white">18 years old</strong>. Persons under 18
            are prohibited from using or registering for the Services.
          </p>
        </div>
      </div>

      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl"
      >
        <span
          class="text-[10px] uppercase tracking-widest text-slate-400 font-bold block mb-4"
        >
          Table of Contents
        </span>

        <ul class="space-y-3" style="font-size: 0.82rem">
          <li
            (click)="scrollToSection(1)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              1
            </span>
            Our Services
          </li>

          <li
            (click)="scrollToSection(2)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              2
            </span>
            Eligibility & User Responsibilities
          </li>

          <li
            (click)="scrollToSection(3)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              3
            </span>
            User Registration & Account Security
          </li>

          <li
            (click)="scrollToSection(4)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              4
            </span>
            Intellectual Property Rights
          </li>

          <li
            (click)="scrollToSection(5)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              5
            </span>
            Products & Virtual Goods
          </li>

          <li
            (click)="scrollToSection(6)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              6
            </span>
            Purchases & Payment
          </li>

          <li
            (click)="scrollToSection(7)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              7
            </span>
            Refund Policy
          </li>

          <li
            (click)="scrollToSection(8)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              8
            </span>
            Software License
          </li>

          <li
            (click)="scrollToSection(9)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              9
            </span>
            Prohibited Activities
          </li>

          <li
            (click)="scrollToSection(10)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              10
            </span>
            User-Generated Content
          </li>

          <li
            (click)="scrollToSection(11)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              11
            </span>
            Contribution License
          </li>

          <li
            (click)="scrollToSection(12)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              12
            </span>
            Guidelines for Reviews & Feedback
          </li>

          <li
            (click)="scrollToSection(13)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              13
            </span>
            Mobile Application License
          </li>

          <li
            (click)="scrollToSection(14)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              14
            </span>
            Social Media Integration
          </li>

          <li
            (click)="scrollToSection(15)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              15
            </span>
            Service Management & Updates
          </li>

          <li
            (click)="scrollToSection(16)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              16
            </span>
            Privacy Policy
          </li>

          <li
            (click)="scrollToSection(17)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              17
            </span>
            Copyright Infringements (DMCA)
          </li>

          <li
            (click)="scrollToSection(18)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              18
            </span>
            Term & Termination
          </li>

          <li
            (click)="scrollToSection(19)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              19
            </span>
            Governing Law & Jurisdiction
          </li>

          <li
            (click)="scrollToSection(20)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              20
            </span>
            Dispute Resolution
          </li>

          <li
            (click)="scrollToSection(21)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              21
            </span>
            Corrections & Errors
          </li>

          <li
            (click)="scrollToSection(22)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              22
            </span>
            Disclaimer of Warranties
          </li>

          <li
            (click)="scrollToSection(23)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              23
            </span>
            Limitation of Liability
          </li>

          <li
            (click)="scrollToSection(24)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              24
            </span>
            Indemnification
          </li>

          <li
            (click)="scrollToSection(25)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              25
            </span>
            User Data & Account Deletion
          </li>

          <li
            (click)="scrollToSection(26)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              26
            </span>
            Electronic Communications
          </li>

          <li
            (click)="scrollToSection(27)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              27
            </span>
            SMS Text Messaging
          </li>

          <li
            (click)="scrollToSection(28)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              28
            </span>
            California Users & Residents Notice
          </li>

          <li
            (click)="scrollToSection(29)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              29
            </span>
            Miscellaneous
          </li>

          <li
            (click)="scrollToSection(30)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
            >
              30
            </span>
            Contact Us
          </li>
        </ul>
      </div>

      <div
        id="section-1"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >1</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Our Services
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Casinoze provides a diverse range of social gaming experiences through
          our website and mobile application, offering free-to-play casino-style
          games, virtual goods, in-game currency, and premium features. Our
          platform includes cross-platform access, regular updates, new game
          releases, seasonal events, and a global chat feature. We reserve the
          right to modify, suspend, or discontinue any aspect of our Services at
          any time.
        </p>
      </div>

      <div
        id="section-2"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >2</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Eligibility & User Responsibilities
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          To use Casinoze' Services, you must be at least 18 years old or the
          legal age of majority in your jurisdiction, whichever is higher. You
          are responsible for ensuring your use of the Services complies with
          all applicable laws. You agree to provide accurate information during
          registration, maintain the confidentiality of your account
          credentials, and accept full responsibility for all activities under
          your account.
        </p>
      </div>

      <div
        id="section-3"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >3</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            User Registration & Account Security
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          You may be required to create an account by providing accurate,
          complete, and current information. You are solely responsible for
          safeguarding your account credentials and all activities conducted
          under your account. We strongly recommend using a strong unique
          password and enabling any available security measures. If you suspect
          unauthorized access, notify us immediately through the support
          channels in your account.
        </p>
      </div>

      <div
        id="section-4"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >4</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Intellectual Property Rights
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          All content, features, and functionality available through the
          Services are the exclusive property of Casinoze, its licensors, or
          other content providers, protected by applicable copyright, trademark,
          patent, and other intellectual property laws. Except as expressly
          permitted, you may not reproduce, distribute, modify, or transmit any
          material from the Services without our prior written consent.
        </p>
      </div>

      <div
        id="section-5"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >5</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Products & Virtual Goods
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          The Services may offer access to virtual goods, including in-game
          currency, items, and other digital content, which hold no real-world
          monetary value and cannot be exchanged for legal tender outside the
          Services. Virtual Goods are licensed to you on a limited, personal,
          non-transferable, and revocable basis. All purchases of Virtual Goods
          are final and non-refundable unless otherwise required by applicable
          law.
        </p>
      </div>

      <div
        id="section-6"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >6</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Purchases & Payment
          </h3>
        </div>
        <p class="mb-4 text-[#b6c2d6]" style="font-size: 0.82rem">
          We accept the following forms of payment:
        </p>

        <div class="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> Visa
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span>
            Mastercard
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> Discover
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> PayPal
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> Cash App
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> Chime
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span> Venmo
          </div>
          <div
            class="bg-[#1e293b66] border border-[#1a2332] px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-2"
          >
            <span class="w-1.5 h-1.5 rounded-full bg-[#f3a83b]"></span>
            Cryptocurrency
          </div>
        </div>

        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          When you purchase, you agree to provide current, complete, and
          accurate billing information. You authorize us and our third-party
          payment processors to charge your chosen payment method for all
          applicable fees. All prices are displayed in U.S. dollars unless
          otherwise stated.
        </p>
      </div>

      <div
        id="section-7"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >7</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Refund Policy
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          All purchases made through our Services are final, and we do not offer
          refunds or exchanges except as required by applicable law. For
          subscription services, cancellation will take effect at the end of the
          current billing cycle. In the event of a technical error or duplicate
          charge, you may request a review by contacting support within 7 days
          of the transaction, including proof of purchase.
        </p>
      </div>

      <div
        id="section-8"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >8</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Software License
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          We grant you a limited, non-exclusive, non-transferable, revocable
          license to access and use our Services solely for personal,
          non-commercial entertainment purposes. You may not copy, modify,
          distribute, sell, lease, reverse engineer, or attempt to extract the
          source code of our software unless expressly permitted by law.
        </p>
      </div>

      <div
        id="section-9"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >9</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Prohibited Activities
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          You agree not to use the Services for any unlawful, harmful, or
          disruptive purposes. This includes cheating, exploiting bugs, engaging
          in fraud, distributing malware, infringing on intellectual property
          rights, harassing other users, or attempting to gain unauthorized
          access to our systems. Any such activity may result in suspension or
          termination of your account.
        </p>
      </div>

      <div
        id="section-10"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >10</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            User-Generated Content
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          By submitting any content through the Services, you grant us the right
          to store, display, reproduce, modify, and distribute such content to
          operate, promote, and improve the Services. You are solely responsible
          for the legality, accuracy, and appropriateness of the content you
          create or share.
        </p>
      </div>

      <div
        id="section-11"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >11</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Contribution License
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          By contributing any ideas, suggestions, or feedback to us, you grant
          us a worldwide, perpetual, irrevocable, royalty-free, transferable
          license to use, reproduce, modify, adapt, publish, translate,
          distribute, and display your contributions in any media without any
          obligation to compensate you.
        </p>
      </div>

      <div
        id="section-12"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >12</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Guidelines for Reviews & Feedback
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          When posting reviews or feedback you agree to provide honest, fair,
          and factual information. Reviews must not contain offensive,
          defamatory, or unlawful language. We reserve the right to monitor,
          edit, remove, or refuse any review that violates these guidelines or
          is otherwise inappropriate.
        </p>
      </div>

      <div
        id="section-13"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >13</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Mobile Application License
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          We grant you a limited, non-exclusive, non-transferable, and revocable
          license to download, install, and use the Casinoze mobile application
          solely for your personal, non-commercial use. You agree not to copy,
          modify, distribute, sell, lease, or reverse engineer the App.
        </p>
      </div>

      <div
        id="section-14"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >14</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Social Media Integration
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Our Services allow you to link, connect, or share content through
          third-party social media platforms. By integrating your Casinoze
          account with these platforms, you authorize us to access certain
          information from your profile as permitted by the platform's settings.
          We are not responsible for the actions or data practices of these
          third parties.
        </p>
      </div>

      <div
        id="section-15"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >15</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Service Management & Updates
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Casinoze reserves the right to modify, suspend, or discontinue any
          feature, content, or service at any time without prior notice. We may
          also release updates to enhance user experience, security, and
          functionality. By continuing to use our Services, you agree to receive
          such updates automatically.
        </p>
      </div>

      <div
        id="section-16"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >16</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Privacy Policy
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Your privacy is important to us. Casinoze collects, processes, and
          stores personal information under applicable data protection laws and
          our Privacy Policy. By using our Services, you consent to the
          collection and use of your information as described in our Privacy
          Policy.
        </p>
      </div>

      <div
        id="section-17"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >17</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Copyright Infringements (DMCA)
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Casinoze respects the intellectual property rights of others. If you
          believe your copyrighted work has been used on our Services in a way
          that constitutes copyright infringement, please notify us with a
          written takedown request. Upon receiving a valid notice, we will
          promptly investigate and remove or disable access to the infringing
          content.
        </p>
      </div>

      <div
        id="section-18"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >18</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Term & Termination
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          These Legal Terms remain in effect until terminated by either you or
          Casinoze. You may terminate your account at any time. We reserve the
          right to suspend, restrict, or terminate your access without prior
          notice if you violate these Legal Terms or engage in conduct that
          harms our community or operations.
        </p>
      </div>

      <div
        id="section-19"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >19</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Governing Law & Jurisdiction
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          These Legal Terms are governed by the laws of the jurisdiction in
          which Casinoze operates. By using our Services, you agree to submit to
          the exclusive jurisdiction of the courts in that jurisdiction for any
          disputes arising from these Legal Terms.
        </p>
      </div>

      <div
        id="section-20"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >20</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Dispute Resolution
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          In the event of any dispute, you agree to first attempt to resolve the
          matter informally by contacting our support team. If unresolved, both
          parties agree to submit to binding arbitration conducted per the rules
          of a recognized arbitration body.
        </p>
      </div>

      <div
        id="section-21"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >21</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Corrections & Errors
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          While we strive to ensure accuracy, Casinoze does not guarantee that
          all content including descriptions, pricing, or technical details is
          error-free. We reserve the right to correct any errors or omissions
          and update information without prior notice.
        </p>
      </div>

      <div
        id="section-22"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >22</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Disclaimer of Warranties
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Casinoze provides its Services on an 'as is' and 'as available' basis
          without any warranties, express or implied. We do not guarantee that
          the Services will be uninterrupted, error-free, secure, or free from
          viruses. Your use of the Services is at your sole risk.
        </p>
      </div>

      <div
        id="section-23"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >23</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Limitation of Liability
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          To the maximum extent permitted by law, Casinoze and its affiliates
          shall not be liable for any indirect, incidental, special,
          consequential, or punitive damages. Our total liability to you shall
          not exceed the amount you have paid to us during the twelve months
          preceding the claim.
        </p>
      </div>

      <div
        id="section-24"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >24</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Indemnification
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          You agree to indemnify, defend, and hold harmless Casinoze, its
          affiliates, officers, directors, employees, and agents from and
          against any claims, damages, liabilities, losses, costs, or expenses
          arising out of your violation of these Legal Terms or your use of the
          Services.
        </p>
      </div>

      <div
        id="section-25"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >25</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            User Data & Account Deletion
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          You may request deletion of your account and associated personal data
          at any time by contacting our support team. Deletion is irreversible
          and you will lose access to all data and content associated with your
          account. Casinoze is not responsible for any loss resulting from
          account deletion.
        </p>
      </div>

      <div
        id="section-26"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >26</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Electronic Communications, Transactions & Signatures
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          By using Casinoze' Services, you consent to receive electronic
          communications from us. All transactions and contracts entered into
          electronically are legally binding and enforceable. Electronic
          signatures have the same legal effect as handwritten signatures.
        </p>
      </div>
      <div
        id="section-27"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >27</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            SMS Text Messaging
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          By providing your mobile phone number and opting in, you agree to
          receive SMS messages from Casinoze related to account notifications,
          promotions, and service updates. Standard messaging and data rates may
          apply. Reply STOP to any message to opt out at any time.
        </p>
      </div>
      <div
        id="section-28"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >28</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            California Users & Residents
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          Notice California residents have rights under the CCPA to access,
          delete, or learn about data we collect. For details, see our Privacy
          Policy or contact support. Unresolved complaints may be directed to
          the California Department of Consumer Affairs.
        </p>
      </div>

      <div
        id="section-29"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >29</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Miscellaneous
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          These Legal Terms constitute the entire agreement between you and Rush
          Plays regarding your use of the Services. Failure to enforce any right
          shall not constitute a waiver. If any provision is found invalid, the
          remaining provisions will continue in full force.
        </p>
      </div>

      <div
        id="section-30"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-3">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            >30</span
          >
          <h3
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide [font-family:'Barlow_Condensed',sans-serif]"
          >
            Contact Us
          </h3>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          If you have any questions, concerns, or requests regarding these Legal
          Terms, please contact Casinoze customer support through the available
          channels on our website or mobile application. We strive to respond
          promptly and assist you in resolving any issues.
        </p>
      </div>

      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl text-center space-y-4"
      >
        <p
          class="leading-relaxed text-[#b6c2d6] [font-family:'Plus_Jakarta_Sans',sans-serif]"
          style="font-size: 0.82rem"
        >
          By using Casinoze you acknowledge that you have read, understood, and
          agreed to these Legal Terms in full. Your continued use of Casinoze
          constitutes your acceptance of any changes.
        </p>
        <div
          class="text-[10px] md:text-xs uppercase tracking-widest text-slate-400 font-bold pt-2"
        >
          We look forward to providing you with a safe, fun, and fair gaming
          experience.
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer mode="landing"></app-footer>
